import isDemo from '@/lib/utils/is_demo';
import { httpBasic } from '../rest';

export function fetchBankInfo(
  httpBasic,
  isDemo,
  micrUrl,
) {
  return {
    async execute({ institutionNumber, transitNumber }) {
      return fetchData(micrUrl, institutionNumber, transitNumber);
    },
  };

  async function fetchData(micrUrl, institutionNumber, transitNumber) {
    if (isDemo()) {
      if (institutionNumber === '003') {
        return {
          address: 'Main Br-Vancouver Royal Centre, 1025 W Georgia St, Vancouver, BC V6E 3N9',
          institution: 'Royal Bank of Canada',
        };
      }
      return {
        isUnknownBank: true,
      };
    }

    try {
      const response = await httpBasic({
        method: 'get',
        url: `${micrUrl}/${institutionNumber}/${transitNumber}/`,
        withCredentials: false,
      });

      return {
        address: response.data.ad,
        institution: response.data.in,
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return {
          isUnknownBank: true,
        };
      }

      throw error;
    }
  }
}

export default fetchBankInfo(httpBasic, isDemo, process.env.MICR_URL);
